<template>
  <vs-row vs-type="block" vs-w="12" id="dashBoardProductReport" class="py-1">
    <branch-product-report-viewer @getExcel="getExcelPersonalReportAccordingTo"  @openVariantPopup="openVariantPopup" ref="branchProductReportViewer"
                                  :report="selectedProduct" @close="selectedProduct = {}"/>
                                  <variant-popup :variantPopup="variantPopup" :variantSums="variantSums" @close="variantPopup=false" ref="variantPopup"/>
    <span v-if="!stop" class="text-xsmall text-secondary bold">
      Ürün Bazlı Ciro Raporu
    </span>
    <vs-row vs-type="flex" vs-w="12" id="productReportFirstThree" class="pb-2">
      <vs-col vs-type="block" vs-w="4" id="productReportSecond" vs-justify="center">
        <div @click="getPersonalReportAccordingTo(secondProd)" class="d-flex w-auto cursor-pointer">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <span class="text-small px-6 text-primary bold border-bottom">
              İkinci
            </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-2">
              <vs-col vs-type="block" vs-w="12" class="text-center">
                <img class=" w-2/5 responsive" :src="getImage(secondProd ? secondProd.imageUrl : null)"/>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <span v-if="secondProd" class="text-primary bold text-smaller w-full text-center">
              {{ secondProd.typeValue }}
            </span>
            </vs-row>
            <vs-row v-if="secondProd" vs-type="flex" vs-w="12">
              <giro-info :order-by="orderBy" :element-to-giro="secondProd"/>
            </vs-row>
          </vs-row>
        </div>
      </vs-col>
      <vs-col vs-type="block" vs-w="4" class="pt-1 mt-2" id="productReportFirst" vs-justify="center">
        <div @click="getPersonalReportAccordingTo(firstProd)" class="d-flex w-auto cursor-pointer">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <span class="text-small px-6 text-primary bold text-center border-bottom">
              Birinci
            </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-2">
              <vs-col vs-type="block" vs-w="12" class="text-center">
                <img class="w-2/5 responsive" :src="getImage(firstProd ? firstProd.imageUrl : null)"/>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <span v-if="firstProd" class="text-primary bold text-smaller w-full text-center">
              {{ firstProd.typeValue }}
            </span>
            </vs-row>
            <vs-row v-if="firstProd" vs-type="flex" vs-w="12">
              <giro-info :order-by="orderBy" :element-to-giro="firstProd"/>
            </vs-row>
          </vs-row>
        </div>
      </vs-col>
      <vs-col vs-type="block" vs-w="4" id="productReportThird" vs-justify="center">
        <div @click="getPersonalReportAccordingTo(thirdProd)" class="d-flex w-auto cursor-pointer">
          <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <vs-row vs-type="flex" vs-w="12" vs-justify="center">
            <span class="text-small px-6 text-primary bold text-center border-bottom">
              Üçüncü
            </span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="center" class="mt-2">
              <vs-col vs-type="block" vs-w="12" class="text-center">
                <img class="w-2/5 responsive" :src="getImage(thirdProd ? thirdProd.imageUrl : null)"/>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mt-1">
            <span v-if="thirdProd" class="text-primary bold text-smaller w-full text-center">
              {{ thirdProd.typeValue }}
            </span>
            </vs-row>
            <vs-row v-if="thirdProd" vs-type="flex" vs-w="12">
              <giro-info :order-by="orderBy" :element-to-giro="thirdProd"/>
            </vs-row>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" id="productReportFilter" class="my-2" v-if="stop">
      <vs-input v-model="filterString" class="w-full border-radius border-all" placeholder="Ürün Arama"/>
    </vs-row>
    <vs-row class="weight-600 text-smaller border-bottom border-secondary py-1">
      <vs-col vs-w="4" vs-type="flex" vs-justify="start">
        <span>
          İsim
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Adet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Ciro
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Maaliyet
        </span>
      </vs-col>
      <vs-col vs-w="2" vs-type="flex" vs-justify="center">
        <span>
          Kar
        </span>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12" class="py-1" vs-justify="space-between"
            v-for="(product,index) in (filteredList && filteredList.length > 0 ? filteredList : [])" :key="index">
      <div @click="getPersonalReportAccordingTo(product)"
           class="d-flex w-full text-xsmall justify-between cursor-pointer border-bottom border-secondary py-1">
        <vs-col vs-type="flex" vs-w="4" vs-align="center">
          <span class="text-primary mr-2 text-xsmall weight-600">
            {{ (index + 4) + '.' }}
          </span>
          <span class="text-primary text-xsmall weight-600">
            {{ product.typeValue }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 1}"
                class="text-secondary weight-600 w-full text-center">
            {{ product.piece.toLocaleString() }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 0}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.amount) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 2}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.cost) }}
          </span>
        </vs-col>
        <vs-col vs-type="flex" vs-w="2" vs-align="center">
          <span :class="{'text-primary text-smaller' : orderBy == 3}"
                class="text-secondary weight-600 w-full text-center">
            {{ $convertCurrency(product.profit) }}
          </span>
        </vs-col>
      </div>
    </vs-row>
    <vs-row v-if="!stop" vs-type="flex" vs-w="12" class="pt-3 pb-1" vs-justify="center" vs-align="center">
      <span @click="openDetailPage" class="text-secondary text-xsmaller bold underline cursor-pointer">
        Detay Sayfasına Git
      </span>
    </vs-row>
    <vs-row v-else vs-type="flex" vs-w="12" class="py-1 border-bottom border-secondary text-secondary text-smaller" vs-align="center">
      <vs-col vs-type="flex" vs-w="4" vs-align="center">
        <span class="text-dark text-smaller bold">
        Toplam
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 1}" class="underline bold">
        {{ totalQuantity.toLocaleString() }} Adet
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 0}" class="underline bold">
          {{ $convertCurrency(totalAmount) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 2}" class="underline bold">
          {{ $convertCurrency(totalCost) }}
        </span>
      </vs-col>
      <vs-col vs-type="flex" vs-w="2" vs-align="center" vs-justify="center">
        <span :class="{'text-primary text-smaller' : orderBy == 3}" class="underline bold">
          {{ $convertCurrency(totalProfit) }}
        </span>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import {getReportTypes} from '@/model/constants/dashboardModels'
import {GetPersonalReportAccordingTo,GetPersonalReportAccordingToForDealer, GetExcelPersonalReportAccordingTo,GetExcelPersonalReportAccordingToForDealer,GetBranchProductSizesReportAccordingToForProduct} from '@/api/Reports'
import BranchProductReportViewer from '../BranchProductReportViewer'
import GiroInfo from '../GiroInfo'
import VariantPopup from '../VariantPopup'
/* eslint-disable */
export default {
  components: {
    BranchProductReportViewer,
    GiroInfo,
    VariantPopup
  },
  props: {
    reportData: {
      type: Array,
      required: true
    },
    orderBy: {
      type: Number,
      required: true
    },
    stop: {
      type: Boolean,
      required: true
    },
    tableOptions: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      filterString: null,
      reportTypes: getReportTypes(),
      selectedProduct: {},
      variantSums: {},
      variantPopup : false
    }
  },
  methods: {
    openVariantPopup(id,accordingId){
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 2).name
      tableParams.accordingId = accordingId;
      GetBranchProductSizesReportAccordingToForProduct(tableParams,id).then(res => {
        this.variantSums = res.data;
      })
      this.variantPopup = true;
    },
    getExcelPersonalReportAccordingTo(accordingId) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 1).name
      tableParams.accordingId = accordingId;
      if (this.$isRegionalCenterBranch()) {
        GetExcelPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetExcelPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement('a');
          link.href = url;
          let now = this.$now.date();
          link.setAttribute('download', 'Ürün Şube Raporu' + now.getDate() + " " + this.$months()[now.getMonth()].name + " " + now.getFullYear() + '.xlsx');
          document.body.appendChild(link);
          link.click();

          this.$vs.notify({
            color: "success",
            title: "Başarılı",
            text: "Excel Export Başarılı !"
          });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Şube Excel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
      
    },
    getPersonalReportAccordingTo(according) {
      let tableParams = _.cloneDeep(this.tableOptions);
      tableParams.accordingTo = this.reportTypes.find(type => type.id === 1).name
      tableParams.accordingId = according.typeId;
      if (this.$isRegionalCenterBranch()) {
        GetPersonalReportAccordingToForDealer(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedProduct.list = res.data.list
          this.selectedProduct.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedProduct.date = this.tableOptions.defaultTimeRange.dName
          } else {
            if (this.tableOptions.dateRange.startDate && this.tableOptions.dateRange.endDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
            } else if (this.tableOptions.dateRange.startDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' ve sonrası'
            } else {
              this.selectedProduct.date = this.tableOptions.dateRange.endDate + ' ve öncesi'
            }
          }
          this.selectedProduct.type = this.reportTypes.find(x => x.name === 'Product')
          this.selectedProduct.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedProduct.branch = this.tableOptions.branch
          this.selectedProduct.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      } else {
        GetPersonalReportAccordingTo(tableParams).then(res => {
        if (res && res.status === 200) {
          this.selectedProduct.list = res.data.list
          this.selectedProduct.variantSums = res.data.variantSums
          if (this.tableOptions.defaultTimeRange) {
            this.selectedProduct.date = this.tableOptions.defaultTimeRange.dName
          } else {
            if (this.tableOptions.dateRange.startDate && this.tableOptions.dateRange.endDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' - ' + this.tableOptions.dateRange.endDate
            } else if (this.tableOptions.dateRange.startDate) {
              this.selectedProduct.date = this.tableOptions.dateRange.startDate + ' ve sonrası'
            } else {
              this.selectedProduct.date = this.tableOptions.dateRange.endDate + ' ve öncesi'
            }
          }
          this.selectedProduct.type = this.reportTypes.find(x => x.name === 'Product')
          this.selectedProduct.orderBy = this.tableOptions.reportByProp ? this.tableOptions.reportByProp.id : 0
          if (this.tableOptions.branch) this.selectedProduct.branch = this.tableOptions.branch
          this.selectedProduct.accordingTo = according
          this.$refs.branchProductReportViewer.isActive = true;
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: " Ürün Personel Raporu Getirilemedi !"
          });
        }
      }).catch(() => {
        {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: " Sunucu Bağlantı Hatası !"
          });
        }
      })
      }
     
    },
    getImage(image) {
      if (!image) return this.$nullImage;
      else return this.$baseUrl + '/' + image;
    },
    openDetailPage() {
      this.$router.push('/pages/reports/product-report').catch(() => {
      })
    }
  },
  computed: {
    totalQuantity() {
      let listTotal = this.filteredList.reduce(function (total, num) {
        return total + num.piece;
      }, 0);
      return listTotal + (this.firstProd ? this.firstProd.piece : 0) + (this.secondProd ? this.secondProd.piece : 0) + (this.thirdProd ? this.thirdProd.piece : 0);
    },
    totalAmount() {
      let listTotal = this.filteredList.reduce(function (total, num) {
        return total + num.amount;
      }, 0);
      return listTotal + (this.firstProd ? this.firstProd.amount : 0) + (this.secondProd ? this.secondProd.amount : 0) + (this.thirdProd ? this.thirdProd.amount : 0);
    },
    totalCost() {
      let listTotal = this.filteredList.reduce(function (total, num) {
        return total + num.cost;
      }, 0);
      return listTotal + (this.firstProd ? this.firstProd.cost : 0) + (this.secondProd ? this.secondProd.cost : 0) + (this.thirdProd ? this.thirdProd.cost : 0);
    },
    totalProfit() {
      let listTotal = this.filteredList.reduce(function (total, num) {
        return total + num.profit;
      }, 0);
      return listTotal + (this.firstProd ? this.firstProd.profit : 0) + (this.secondProd ? this.secondProd.profit : 0) + (this.thirdProd ? this.thirdProd.profit : 0);
    },
    listFromThree() {
      return this.reportData.splice(3)
    },
    filteredList() {
      if (!this.filterString) return this.listFromThree.filter(x => x.typeValue !== 'Kampanya')
      return this.listFromThree.filter(x =>x => x.typeValue !== 'Kampanya' && x.typeValue.toLowerCase().includes(this.filterString.toLowerCase()))
    },
    secondProd() {
      if (!this.reportData) return {}
      return this.reportData[1];
    },
    firstProd() {
      if (!this.reportData) return {}
      return this.reportData[0];
    },
    thirdProd() {
      if (!this.reportData) return {}
      return this.reportData[2];
    }
  },
}

</script>

<style>
#productReportThird,
#productReportSecond {
  padding-top: 2.5rem;
}

</style>
